import { render, staticRenderFns } from "./InfiniteFetcher.vue?vue&type=template&id=a2a20c82&scoped=true&lang=pug"
import script from "./InfiniteFetcher.vue?vue&type=script&lang=js"
export * from "./InfiniteFetcher.vue?vue&type=script&lang=js"
import style0 from "./InfiniteFetcher.vue?vue&type=style&index=0&id=a2a20c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a20c82",
  null
  
)

export default component.exports